// FLAGS: none
// Login-screen message pointing a locked-out staff user at IT support.
import React from "react";
import { useTranslation } from "react-i18next";
import { IT_SUPPORT_EMAIL, IT_SUPPORT_SLACK_URL } from "../utils/constants";

const LockedAccountMessage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <span style={{ whiteSpace: "nowrap" }}>
      {t("LoginView.LockedAccount.Prefix")}{" "}
      <a href={IT_SUPPORT_SLACK_URL} target="_blank" rel="noopener noreferrer">
        Slack
      </a>{" "}
      {t("LoginView.LockedAccount.Suffix")}{" "}
      <a href={`mailto:${IT_SUPPORT_EMAIL}?subject=Account Locked`}>
        {IT_SUPPORT_EMAIL}
      </a>
      .
    </span>
  );
};

export default LockedAccountMessage;
